// src/components/Shared/Footer.js

import React from 'react';

function Footer() {
  return (
    <footer className="bg-gray-800 text-white py-6">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col md:flex-row justify-between items-center">
        <p className="text-sm">&copy; {new Date().getFullYear()} TreePlanter. All rights reserved.</p>
        <div className="flex space-x-4 mt-4 md:mt-0">
          <a href="#" className="hover:text-gray-400">
            {/* Facebook Icon */}
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-6 w-6 fill-current"
              viewBox="0 0 24 24"
            >
              <path d="M22.675 0h-21.35C.597 0 0 .597 0 1.325v21.351C0 23.403.597 24 1.325 24h11.495v-9.294H9.691v-3.622h3.129V8.413c0-3.1 1.893-4.788 4.659-4.788 1.325 0 2.464.099 2.797.143v3.24l-1.918.001c-1.504 0-1.796.716-1.796 1.764v2.314h3.588l-.467 3.622h-3.121V24h6.116C23.403 24 24 23.403 24 22.676V1.325C24 .597 23.403 0 22.675 0z" />
            </svg>
          </a>
          <a href="#" className="hover:text-gray-400">
            {/* Twitter Icon */}
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-6 w-6 fill-current"
              viewBox="0 0 24 24"
            >
              <path d="M24 4.557a9.83 9.83 0 01-2.828.775 4.932 4.932 0 002.165-2.724c-.951.555-2.005.959-3.127 1.184A4.916 4.916 0 0016.616 3c-2.73 0-4.944 2.214-4.944 4.943 0 .388.043.764.127 1.124C7.691 8.867 4.066 6.869 1.64 3.149a4.822 4.822 0 00-.666 2.475c0 1.708.87 3.213 2.188 4.096a4.903 4.903 0 01-2.229-.616c-.054 1.995 1.407 3.86 3.444 4.27a4.936 4.936 0 01-2.224.084c.63 1.953 2.445 3.376 4.6 3.416A9.868 9.868 0 010 19.54a13.94 13.94 0 007.548 2.209c9.056 0 14.01-7.506 14.01-14.01 0-.213-.005-.425-.014-.636A10.012 10.012 0 0024 4.557z" />
            </svg>
          </a>
          <a href="#" className="hover:text-gray-400">
            {/* Instagram Icon */}
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-6 w-6 fill-current"
              viewBox="0 0 24 24"
            >
              <path d="M12 2.163c3.204 0 3.584.012 4.85.07 1.366.062 2.633.35 3.608 1.325.975.975 1.263 2.242 1.325 3.608.058 1.266.07 1.646.07 4.85s-.012 3.584-.07 4.85c-.062 1.366-.35 2.633-1.325 3.608-.975.975-2.242 1.263-3.608 1.325-1.266.058-1.646.07-4.85.07s-3.584-.012-4.85-.07c-1.366-.062-2.633-.35-3.608-1.325-.975-.975-1.263-2.242-1.325-3.608C2.175 15.747 2.163 15.367 2.163 12s.012-3.584.07-4.85c.062-1.366.35-2.633 1.325-3.608.975-.975 2.242-1.263 3.608-1.325C8.416 2.175 8.796 2.163 12 2.163zm0-2.163C8.741 0 8.332.014 7.052.072 5.775.13 4.638.418 3.682 1.375 2.727 2.332 2.439 3.468 2.381 4.745 2.323 6.025 2.309 6.434 2.309 12c0 5.566.014 5.975.072 7.255.058 1.277.346 2.413 1.303 3.37.957.957 2.093 1.245 3.37 1.303 1.28.058 1.689.072 7.255.072s5.975-.014 7.255-.072c1.277-.058 2.413-.346 3.37-1.303.957-.957 1.245-2.093 1.303-3.37.058-1.28.072-1.689.072-7.255s-.014-5.975-.072-7.255c-.058-1.277-.346-2.413-1.303-3.37C19.069.418 17.933.13 16.656.072 15.376.014 14.967 0 12 0z" />
              <path d="M12 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zm0 10.162a4 4 0 110-8 4 4 0 010 8z" />
              <circle cx="18.406" cy="5.594" r="1.44" />
            </svg>
          </a>
          {/* Add more social icons as needed */}
        </div>
      </div>
    </footer>
  );
}

export default Footer;
